import BackButton, { DEFAULT_SELECTOR } from 'CoreComponents/backButton';

document.querySelectorAll(DEFAULT_SELECTOR).forEach(backButton => {
  new BackButton(backButton);
});
